// import React from 'react'
// import t from 'prop-types'
import { connect } from 'react-redux';
import BarraHerramientas from '../herramientas/barra-herramientas';
import * as actions from '../actions';
import * as selectors from '../selectors';
import * as selectorsBarraHerramientas from '../selectors/barra-herramientas';
import * as selectorsPizarra from '../pizarra/selectors';
import * as selectorsMascaras from '../mascaras/selectors';
import * as selectorsCartulina from '../cartulina/selectors';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var visible = selectorsBarraHerramientas.getVisible(state);
  var posicion = selectorsBarraHerramientas.getPosicion(state);
  var botones = selectorsBarraHerramientas.getBotones(state);
  var herramientaIdSeleccionado = selectorsBarraHerramientas.getHerramientaIdSeleccionado(state);
  var colorLapiz = selectorsPizarra.getColorLapiz(state);
  var grosorLapiz = selectorsPizarra.getGrosorLapiz(state);
  var colorMarcador = selectorsPizarra.getColorMarcador(state);
  var grosorMarcador = selectorsPizarra.getGrosorMarcador(state);
  var grosorBorrador = selectorsPizarra.getGrosorBorrador(state);
  var mascarasActivas = selectorsMascaras.getActivas(state);
  var cartulinaActiva = selectorsCartulina.getActiva(state);
  var imagenUsuarioVisible = selectors.getImagenUsuarioVisible(state);
  var textosUsuarioVisible = selectors.getTextosUsuarioVisible(state);
  var mostrarActivo = !imagenUsuarioVisible && !textosUsuarioVisible;
  return {
    visible: visible,
    x: posicion.x,
    y: posicion.y,
    botones: botones,
    herramientaIdSeleccionado: herramientaIdSeleccionado,
    colorLapiz: colorLapiz,
    grosorLapiz: grosorLapiz,
    colorMarcador: colorMarcador,
    grosorMarcador: grosorMarcador,
    grosorBorrador: grosorBorrador,
    mascarasActivas: mascarasActivas,
    cartulinaActiva: cartulinaActiva,
    mostrarActivo: mostrarActivo
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOcultar: function onOcultar() {
      dispatch(actions.toggleHerramientas());
    },
    onPresionado: function onPresionado(herramientaId, grupo, valor) {
      dispatch(actions.seleccionarHerramienta(herramientaId, grupo, valor));
    }
  };
};

var BarraHerramientasContainer = connect(mapStateToProps, mapDispatchToProps)(BarraHerramientas);
export default BarraHerramientasContainer;